import { FC } from "react";
import { Typography, Box, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core";

import { AuthImageProps } from "../../interfaces";

const AuthImage: FC<AuthImageProps> = ({ image }) => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box px={0} hidden={isActive}>
      <Typography variant="h1" color="secondary">
        Start Your <br />
        <Typography component="span" variant="h1" color="primary">
          Web3 Journey
        </Typography>
      </Typography>
      {!isActive && (
        <>
          <Typography variant="body1">
            <Box component="b" fontWeight="bold">
              100% refundable deals for secure investing after listing.
            </Box>
            <br />{" "}
            <Box className="black" component="span" fontStyle="italic" >
              Powered by
            </Box>{" "}
            <Box component="b" fontWeight="bold" fontStyle="italic" >
              GAINS.
            </Box>
          </Typography>
          <Box mt={4} width={"80%"}>
            <img src={image} className="img-fluid" alt="Gains" />
          </Box>
        </>
      )}
    </Box>
  );
};

export default AuthImage;
